import { render, staticRenderFns } from "./StockBulkImport.vue?vue&type=template&id=58978613&scoped=true"
import script from "./StockBulkImport.vue?vue&type=script&lang=js"
export * from "./StockBulkImport.vue?vue&type=script&lang=js"
import style0 from "./StockBulkImport.vue?vue&type=style&index=0&id=58978613&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58978613",
  null
  
)

export default component.exports